<template>
  <a-modal
    :visible="true"
    width="470px"
    :body-style="bodyStyle"
    centered
    :footer="null"
    @cancel="handleCloseModalHeader"
  >
    <div class="container__inactive">
      <img class="image__delete" src="@/app/users/assets/profiles/delete.png" alt="delete" />
      <p class="text__alert">¿Estás seguro de eliminar la base</p>
      <p class="text__alert">“{{ record.name }}”?</p>
    </div>
    <div class="container__info">
      <p class="text">Sucederán las siguientes acciones:</p>
      <ul>
        <li>Se desactivarán las estrategias asociadas a esta base.</li>
        <li>Los tickets se finalizarán automáticamente.</li>
      </ul>
    </div>
    <a-form class="form" layout="vertical">
      <a-row :gutter="24">
        <a-col span="24">
          <a-form-item class="form__item">
            <template #label>
              <span> Escribe la palabra <span class="strong">"Eliminar"</span> </span>
            </template>
            <a-auto-complete
              v-model:value="confirmText"
              placeholder="Escribe aquí..."
              :class="{ 'ant-form-item-has-error': isTextIncorrect }"
            />
            <p v-if="isTextIncorrect" class="form__error">Palabra inválida</p>
          </a-form-item>
        </a-col>
      </a-row>
    </a-form>
    <div class="button__disabled">
      <a-button
        style="width: 100%"
        :disabled="confirmText !== 'Eliminar'"
        class="footer__delete"
        type="primary"
        @click="handleCloseModal"
      >
        Eliminar base
      </a-button>
    </div>
  </a-modal>
</template>

<script>
import { defineComponent, ref } from "vue";
import { UserStatus } from "@/app/shared/utils/enums";

export default defineComponent({
  name: "InactiveUserModal",
  props: {
    record: {
      type: Object,
      default: null,
    },
    visible: {
      type: Boolean,
      default: false,
    },
  },
  setup() {
    const confirmText = ref("");
    const bodyStyle = {
      height: "440px",
      padding: "30px 37px 37px",
      loading: false,
    };
    return {
      confirmText,
      bodyStyle,
    };
  },
  data() {
    return {
      UserStatus,
    };
  },
  computed: {
    isTextIncorrect() {
      return this.confirmText != "Eliminar" && this.confirmText.length > 0;
    },
  },
  methods: {
    handleCloseModal() {
      this.$emit("onCancel");
      this.updateStatus();
    },
    handleCloseModalHeader() {
      this.$emit("onCloseModal");
    },
    updateStatus() {
      try {
        this.$store.dispatch("deleteBase", this.record.id);
        this.$message.success(`Se ha eliminado la base "${this.record.name}" correctamente`);
      } catch (error) {
        this.$message.error("Error al eliminar la base");
      }
      this.$emit("onCloseModal");
    },
  },
});
</script>

<style lang="sass" scoped>
.image__delete
  margin-bottom: 10px

.text__alert
  font-size: 16px
  font-weight: 600
  margin-bottom: 0
  color: $gray-13

.text
  margin-bottom: 20px
  margin-top: 20px

.button__disabled
  margin-top: 10px

.strong
  font-weight: 600

.footer__delete
  margin-bottom: 20px

.container__inactive
  text-align: center

.container__info
  margin-bottom: 18px

.form__error
  color: $red-6
  margin-top: 5px
  margin-bottom: -30px
</style>
